module.exports = __webpack_public_path__ + "img/opencart.2d79bcc6.png";